'use strict';

var _ = require('lodash');

var getViewportWidth = require('../get-viewport-width');
var mediaQueryChange = require('../media-query-change');

var mobileBreakpoint = '1024px';
/**
 * Fires the optimize activate event with the device type.
 */
var setDeviceType = function setDeviceType() {
  if (!_.get(window, 'matchMedia')) {
    return;
  }
  var mediaQuery = window.matchMedia('(max-width: ' + mobileBreakpoint + ')');
  var viewportWidth = getViewportWidth();
  window.dataLayer.push({
    siteVersion: mediaQuery.matches ? 'mobile' : 'desktop',
    viewportWidth: viewportWidth
  });

  mediaQuery.addListener(mediaQueryChange);
};

module.exports = setDeviceType;